export const CircleProgress = (props: React.SVGProps<SVGSVGElement> & { ref?: React.Ref<SVGSVGElement> }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      className="fill-primary"
      d="M19 12c0-3.976-3.024-7-7-7V3a9 9 0 0 1 9 9h-2ZM12 19c3.976 0 7-3.024 7-7h2a9 9 0 0 1-9 9v-2ZM5 12c0 3.976 3.024 7 7 7v2a9 9 0 0 1-9-9h2Z"
    />
  </svg>
)
